import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Header from './components/Header';
import WeekDays from './components/WeekDays';
import Dates from './components/Dates';
import './Calendar.scss';


export default class Calendar extends Component {

  static propTypes = {
    disablePast: PropTypes.bool,
    minDate: PropTypes.object,
    secondaryDate: PropTypes.arrayOf(PropTypes.object),
    onSelect: PropTypes.func,
    contrast: PropTypes.bool,
    dayNamesFull: PropTypes.arrayOf(PropTypes.string),
    monthNamesFull: PropTypes.arrayOf(PropTypes.string),
    weekStartDay: PropTypes.number,
    dayNamesShort: PropTypes.arrayOf(PropTypes.string),
    newSelectedDt: PropTypes.object
  }

  static defaultProps = {
    disablePast: false,
    contrast: false,
    weekStartDay: 0,
    dayNamesShort: ["S", "M", "T", "W", "T", "F", "S"],
    dayNamesFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    monthNamesFull: ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"],
    secondaryDate: []
  }

  constructor(props) {
    super(props);

    const date = new Date();
    const { minDate, disablePast, contrast, dayNamesFull, monthNamesFull,
            weekStartDay, secondaryDate, dayNamesShort, newSelectedDt } = this.props;

    this.state = {
      year: newSelectedDt ? newSelectedDt.getFullYear() : date.getFullYear(),
      month: newSelectedDt ? newSelectedDt.getMonth() : date.getMonth(),
      selectedYear: newSelectedDt ? newSelectedDt.getFullYear() : date.getFullYear(),
      selectedMonth: newSelectedDt ? newSelectedDt.getMonth() : date.getMonth(),
      selectedDate: newSelectedDt ? newSelectedDt.getDate() : date.getDate(),
      selectedDt: newSelectedDt,
      weekStartDay: weekStartDay,
      minDate: minDate ? minDate : null,
      secondaryDate: secondaryDate,
      disablePast: disablePast,
      contrast: contrast,
      dayNames: dayNamesShort,
      dayNamesFull: dayNamesFull,
      monthNamesFull: monthNamesFull,
      firstOfMonth: null,
      daysInMonth: null
    }
  }

  calc = (year, month) => {
    const selectInverse = this.props.contrast ? '-inverse' :'';
    if (this.state.selectedElement) {
      if (this.state.selectedMonth !== month || this.state.selectedYear !== year) {
        this.state.selectedElement.classList.remove(`pe-cal-selected${selectInverse}`);
      } else {
        this.state.selectedElement.classList.add(`pe-cal-selected${selectInverse}`);
      }
    }
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate()
    };
  }

  componentWillMount() {
    this.setState(this.calc.call(null, this.state.year, this.state.month));
  }

  componentDidMount() {
    this.dates.addEventListener('keydown', this.handleKeys);
  }

  componentWillUnmount() {
    this.dates.removeEventListener('keydown', this.handleKeys);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onSelect && prevState.selectedDt !== this.state.selectedDt) {
      this.props.onSelect.call(ReactDOM.findDOMNode(this), this.state);
    }
  }

  handleKeys = (e) => {
    let which = e.which || e.keyCode;

    switch (which) {
      case 13: // space
      case 32: // enter
      case 37: // left arrow
      case 38: // up arrow
      case 39: // right arrow
      case 40: // down arrow
        e.preventDefault();
        break;
      default: break;
    }

    switch (which) {
      case 13: // space
      case 32: // enter
        this.enterSelect();
        break;
      case 37: this.leftArrow(); break; // left arrow
      case 38: this.upArrow(); break; // up arrow
      case 39: this.rightArrow(); break; // right arrow
      case 40: this.downArrow(); break; // down arrow
      default: break;
    }
  }

  leftArrow = () => {
    if (this.state.selectedDate <= 1) {
      this.getPrev();
      this.setState({selectedDate: this.state.daysInMonth});
      document.getElementById(`day${this.state.daysInMonth}`).focus();
    } else {
      this.setState({selectedDate: this.state.selectedDate - 1});
      document.getElementById(`day${this.state.selectedDate}`).focus();
    }
  }

  rightArrow = () => {
    if (this.state.selectedDate >= this.state.daysInMonth) {
      this.getNext();
      this.setState({selectedDate: 1});
      document.getElementById('day1').focus();
    } else {
      this.setState({selectedDate: this.state.selectedDate + 1});
      document.getElementById(`day${this.state.selectedDate}`).focus();
    }
  }

  upArrow = () => {
    if (this.state.selectedDate - 7 < 1) {
      const dayDiff = this.state.selectedDate - 7;
      this.getPrev();
      this.setState({selectedDate: this.state.daysInMonth + dayDiff});
      document.getElementById(`day${this.state.selectedDate}`).focus();
    } else {
      this.setState({selectedDate: this.state.selectedDate - 7});
      document.getElementById(`day${this.state.selectedDate}`).focus();
    }
  }

  downArrow = () => {
    if (this.state.selectedDate + 7 > this.state.daysInMonth) {
      const diff = (this.state.selectedDate + 7) - this.state.daysInMonth;
      this.setState({selectedDate: diff});
      this.getNext();
      document.getElementById(`day${this.state.selectedDate}`).focus();
    } else {
      this.setState({selectedDate: this.state.selectedDate + 7});
      document.getElementById(`day${this.state.selectedDate}`).focus();
    }
  }

  getPrev = () => {
    const state = {};
    if (this.state.month > 0) {
      state.month = this.state.month - 1;
      state.year = this.state.year;
    } else {
      state.month = 11;
      state.year = this.state.year - 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);
  }

  getNext = () => {
    const state = {};
    if (this.state.month < 11) {
      state.month = this.state.month + 1;
      state.year = this.state.year;
    } else {
      state.month = 0;
      state.year = this.state.year + 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);
  }

  selectDate = (year, month, date, element) => {
    if (this.state.selectedElement) {
      this.state.selectedElement.classList.remove('pe-cal-selected');
      this.state.selectedElement.removeAttribute('aria-selected');
    }
    element.target.classList.add('pe-cal-selected');
    element.target.setAttribute('aria-selected', true);
    this.setState({
      selectedYear: year,
      selectedMonth: month,
      selectedDate: date,
      selectedDt: new Date(year, month, date),
      selectedElement: element.target
    });
  }

  enterSelect = () => {
    const days = document.querySelectorAll('div.pe-cal-cell-square');
    if (this.state.selectedElement) {
      this.state.selectedElement.classList.remove('pe-cal-selected');
      this.state.selectedElement.removeAttribute('aria-selected');
    }
    if (document.activeElement.hasAttribute('aria-disabled')) return;
    for (let i = 0; i < days.length; i++) {
      if (document.activeElement === days[i]) {
        document.activeElement.classList.add('pe-cal-selected');
        document.activeElement.setAttribute('aria-selected', true);
        this.setState({
          selectedYear: this.state.year,
          selectedMonth: this.state.month,
          selectedDate: parseInt(document.activeElement.innerText),
          selectedDt: new Date(this.state.year, this.state.month, parseInt(document.activeElement.innerText)),
          selectedElement: document.activeElement
        });
      }
    }
  }

  render() {
    const { monthNamesFull, month, year, dayNames, weekStartDay, daysInMonth,
            firstOfMonth, selectedDate, disablePast, minDate, dayNamesFull,
            contrast, secondaryDate, selectedDt } = this.state;

    const colorSwap = contrast ? 'calendar-contrast' :'';

    return (
      <div className={`pe-calendar ${colorSwap}`}>
        <div className="pe-inner">
          <Header
            monthNames={monthNamesFull}
            month={month}
            contrast={contrast}
            year={year}
            onPrev={this.getPrev}
            onNext={this.getNext} />

          <WeekDays
            contrast={contrast}
            dayNames={dayNames}
            dayNamesFull={dayNamesFull}
            weekStartDay={weekStartDay} />

          <Dates
            datesRef={el => this.dates = el}
            selectedDt={selectedDt}
            month={month}
            monthNames={monthNamesFull}
            year={year}
            contrast={contrast}
            selectedDate={selectedDate}
            daysInMonth={daysInMonth}
            dayNamesFull={dayNamesFull}
            firstOfMonth={firstOfMonth}
            weekStartDay={weekStartDay}
            onSelect={this.selectDate}
            disablePast={disablePast}
            minDate={minDate}
            secondaryDate={secondaryDate} />
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js